<div class="card-body mb-5">

  <!-- Errors -->
  <div
    *ngFor="let error of errorsList"
    class="alert alert-danger text-center"
    role="alert"
  >
    {{ error }}
  </div>

  <!-- Top bar: Return button left, Total Results right -->
  <div class="d-flex justify-content-between align-items-center mt-3 mb-3">
    <button
      *ngIf="displayBackButton"
      type="button"
      class="btn bottom-btn btn-primary px-3"
      (click)="returnToSearch()"
    >
      <span class="arrow left float-start">
        <i class="fa fa-chevron-left"></i>
      </span>
      <span class="ms-1">Return to Search</span>
    </button>

    <strong *ngIf="displayBackButton && permits?.length > 0">
      Total Results: {{ permits?.length }}
    </strong>
  </div>

  <!-- No results -->
  <div
    *ngIf="displayBackButton && permits?.length === 0"
    class="text-center"
    style="min-height: 382px"
  >
    <h3 class="mt-5 pt-5">No Records Found.</h3>
  </div>

  <!-- Results table -->
  <div *ngIf="permits?.length > 0">
    <div class="table-responsive">
      <table
        class="table table-striped"
        [mfData]="permits"
        #mf="mfDataTable"
        [mfRowsOnPage]="15"
      >
        <thead>
          <tr>
            <th><mfDefaultSorter by="ltfIdNo">LTF #</mfDefaultSorter></th>
            <th><mfDefaultSorter by="companyName">Company Name</mfDefaultSorter></th>
            <th><mfDefaultSorter by="facilityName">Facility Name</mfDefaultSorter></th>
            <th><mfDefaultSorter by="countyCode">Facility County</mfDefaultSorter></th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let permit of mf.data">
            <td>{{ permit?.ltfIdNo }}</td>
            <td>{{ permit?.companyName }}</td>
            <td>{{ permit?.facilityName }}</td>
            <td>{{ getCountyName(permit?.countyCode) }}</td>
            <td>
              <a
               class = "mydeq-teal" 
                style="cursor: pointer; text-decoration: underline;"
                (click)="viewDetails(permit)"
              >VIEW</a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">
              <div class="float-end">
                <mfBootstrapPaginator></mfBootstrapPaginator>
              </div>
              <div class="clearfix"></div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- Bottom Return button -->
  <div class="mt-3">
    <button
      *ngIf="displayBackButton"
      type="button"
      class="btn bottom-btn btn-primary px-3 mb-3"
      (click)="returnToSearch()"
    >
      <span class="arrow left float-start">
        <i class="fa fa-chevron-left"></i>
      </span>
      <span class="ms-1">Return to Search</span>
    </button>
  </div>

</div>
